export { TagSchema } from './model.tag';
export type { Tag } from './model.tag';
